import { bus, helper } from '@/utils'

export default {
  name: 'SolutionStatusTest',
  beforeDestroy () {
    bus.$off('show-solution-status-test')
  },
  created () {
    bus.$on('show-solution-status-test', ({ show }) => {
      if (show) {
        this.showModal = true
        this.data.SolutionAccount = this.$store.state.user
      }
    })
  },
  data () {
    return {
      component: 'solutionStatusTest',
      data: {
        SolutionAccount: '',
        SolutionPassword: '',
        RecipientList: ''
      },
      description: {
        class: 'description',
        text: 'solutionStatusTestDialogDescription'
      },
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      labelWidth: '150px',
      loading: false,
      recipients: {
        label: 'solutionStatusTestInputRecipientLabel',
        tips: 'solutionStatusTestInputRecipientsTip'
      },
      rules: {
        SolutionAccount: [{
          required: true, message: 'Please input'
        }],
        SolutionPassword: [],
        RecipientList: []
      },
      showModal: false,
      support: {
        href: 'https://support.exosite.com/hc/en-us/requests/new',
        text: 'solutionStatusTestDialogSupport'
      }
    }
  },
  methods: {
    closePopup () {
      this.reset()
      this.showModal = false
    },
    reset () {
      this.data = {
        SolutionAccount: '',
        SolutionPassword: '',
        RecipientList: ''
      }
      this.loading = false
      this.$nextTick(() => {
        this.$validator.reset()
        this.$validator.errors.clear()
      })
    },
    triggerTest () {
      return this.$validator.validateAll()
        .then(async (result) => {
          if (result) {
            this.loading = true

            try {
              const RecipientList = this.data.RecipientList
              const data = Object.assign({}, this.data, { RecipientList })

              const trigger = await this.$api.triggerOnlineTesting(data)

              if (trigger.status !== 200) return

              this.$message({
                message: this.$t('solutionStatusTestSuccessMessage'),
                showClose: true,
                type: 'success'
              })
            } catch (error) {
              helper.showErrorMessage(this, this.component, error)
            }

            this.closePopup()
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SolutionStatusTest/SolutionStatusTest.js